import React, { useContext, useEffect } from 'react';
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Outlet,
    useNavigate,
} from 'react-router-dom';
import { AuthProvider, AuthContext } from './contexts/AuthContext';

// Layout Principal
import MainLayout from './components/MainLayout';

// Páginas Públicas
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';

// Páginas Protegidas
import Home from './pages/Home';
import SumarioVeiculos from './pages/Sumario';
import Localizacao from './pages/Localizacao';
import Trajetos from './pages/Trajetos';
// Rotas adicionais (placeholders ou reais)
const SumarioPage = () => <SumarioVeiculos />;
const LocalizacaoPage = () => <Localizacao />;
const TrajetosPage = () => <Trajetos />;
const UltimosRegistrosPage = () => <div>Página Últimos Registros</div>;
const DeslocamentosReportPage = () => <div>Relatório Deslocamentos</div>;
const VelocidadeReportPage = () => <div>Relatório Velocidade</div>;
const AssistenteReportPage = () => <div>Relatório Assistente</div>;

function App() {
    return (
        <Router>
            <AuthProvider>
                <Routes>
                    {/* Rotas públicas */}
                    <Route path="/" element={<Login />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />

                    {/* Rotas protegidas com layout */}
                    <Route element={<ProtectedLayout />}>
                        <Route path="/inicio" element={<Home />} />
                        <Route path="/sumario" element={<SumarioPage />} />
                        <Route path="/localizacao" element={<LocalizacaoPage />} />
                        <Route path="/trajetos" element={<TrajetosPage />} />
                        <Route path="/ultimos-registros" element={<UltimosRegistrosPage />} />
                        <Route path="/relatorios/deslocamentos" element={<DeslocamentosReportPage />} />
                        <Route path="/relatorios/velocidade" element={<VelocidadeReportPage />} />
                        <Route path="/relatorios/assistente" element={<AssistenteReportPage />} />
                        <Route index element={<Home />} />
                    </Route>

                    {/* Rota fallback (pode ser uma página 404 personalizada) */}
                    <Route path="*" element={<Login />} />
                </Routes>
            </AuthProvider>
        </Router>
    );

    // ProtectedLayout com redirecionamento via useNavigate
    function ProtectedLayout() {
        const { userToken, loading } = useContext(AuthContext);
        const navigate = useNavigate();

        useEffect(() => {
            if (!loading && !userToken) {
                navigate('/login', { replace: true });
            }
        }, [loading, userToken, navigate]);

        if (loading) {
            return <div style={{ padding: 20 }}>Carregando...</div>;
        }

        if (!userToken) {
            return null; // evita piscar layout antes do redirecionamento
        }

        return (
            <MainLayout>
                <Outlet />
            </MainLayout>
        );
    }
}

export default App;
